import { css } from '@emotion/css';

export const highlightedCardClass = css`
  transition: background-color 0.2s ease-out;

  &[aria-current='true'] {
    background-color: var(--mantine-color-blue-0);
  }

  border-bottom: 1px solid var(--mantine-color-gray-2);

  &:last-of-type {
    border-bottom: none;
  }
`;
